import {JsonAdapter} from "../helpers/JsonAdapter";

export class DiaryFile {

  public static VIDEO = {
    YOUTUBE: 'youtube',
    DAILYMOTION: 'dailymotion',
    VIMEO: 'vimeo',
    VIDEO: 'video'
  };

  id: string = "";
  size: number = 0;
  content_type: string = "";
  filename: string = "";
  created_at: string = "";
  url: string = "";

  // for videos
  name?: string = "";
  description?: string = "";

  editing: boolean = false;
  renaming: boolean = false;

  static create(object:any): DiaryFile {
    const item = JsonAdapter.fill(new DiaryFile(), object);

    return item;
  }

  static createMultiple(objects: DiaryFile[]): DiaryFile[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(DiaryFile.create(objects[i]));
    }
    return items;
  }

  get videoType() {
    if(this.url.indexOf('youtu') > -1) {
      return {
        id: DiaryFile.VIDEO.YOUTUBE,
        name: 'Youtube',
        icon: 'faYoutube',
        class: 'color-youtube'
      }
    } else if(this.url.indexOf('vim')  > -1) {
      return {
        id: DiaryFile.VIDEO.VIMEO,
        name: 'Vimeo',
        icon: 'faVimeo',
        class: 'color-vimeo'
      }
    } else if(this.url.indexOf('daily')  > -1) {
      return {
        id: DiaryFile.VIDEO.DAILYMOTION,
        name: 'Dailymotion',
        icon: 'faDailymotion',
        class: 'color-dailymotion'
      }
    } else {
      return {
        id: DiaryFile.VIDEO.VIDEO,
        name: 'Video',
        icon: 'faClapperboardPlay',
        class: 'text-primary'
      }
    }
  }

  get youtubeId() {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = this.url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }

  get dailymotionId() {
    const m = this.url.match(/^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/);
    if (m !== null) {
      if(m[4] !== undefined) {
        return m[4];
      }
      return m[2];
    }
    return null;
  }

  get vimeoId() {
    const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
    const parseUrl = this.url.match(regExp);
    if(parseUrl) {
      return parseUrl[5]
    }

    return null;
  }

  get title() {
    return this.filename;
  }

  get fileExtension() {
    return (this.filename || this.name)?.split('.').pop();
  }

  get fileIcon() {
    let extension = this.fileExtension;
    switch(extension) {
      case 'pdf': return 'faFilePdf';
      case 'doc':
      case 'docx':
        return 'faFileWord';
      case 'xls':
      case 'xlsx':
        return 'faFileExcel';
      default:
        return 'faFile'
    }
  }

  get thumbnail() {
    return this.url + "?thumbnail=true";
  }

  get isImage() {
    return this.content_type.indexOf('image') > -1;
  }

}
